/* eslint-disable */
import { Form, Col, Row, Container } from "react-bootstrap";
import { FaComment } from "react-icons/fa6";

import NotesEditor from "../../Notes/Editor";
import { NotesAPI } from "../../../connections/Notes";
import { useEffect, useState, useCallback } from "react";

import ModernViewer from "../../Notes/ModernViewer";

// const dateFormat = "MM/dd/yyyy HH:mm";

function NotesTab(props) {
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState();
  const [noteContents, setNoteContents] = useState({
    message: "",
    private: false,
    important: false,
    edit: false,
    created: new Date(),
    id: "",
  });

  const editNote = (message) => {
    setShowModal(true);
    setNoteContents(message);
  };

  const deleteNote = (noteID) => {
    return NotesAPI.delete(
      props.problem.number,
      props.outage.number,
      noteID
    ).then(() => {
      setTimeout(() => {
        refreshNotes();
      }, 2000);
    });
  };

  const refreshNotes = useCallback(() => {
    if (!props.problem?.number || !props.outage?.number) return;
    NotesAPI.get(props.problem.number, props.outage.number).then((notes) => {
      setNotes(notes);
    });
  }, [props.problem?.number, props.outage?.number]);

  // Adopt the parent's notes only when the note set or the target
  // problem/outage actually changes — NOT on every re-render. props.notes
  // holds a stable reference across the field-patch polling re-renders
  // (ProblemForm's `notes` state is only rewritten by updateNotes), so a note
  // just posted here (reflected in local state via refreshNotes) is no longer
  // clobbered when unrelated polling re-renders the parent. This was the
  // QC-05 note-wipe race (US2014862): the old `[props]` dependency re-ran on
  // every render and blindly reset notes to the parent's stale snapshot.
  useEffect(() => {
    if (props.outage && props.problem) {
      setNotes(props.notes);
    }
  }, [props.notes, props.problem?.number, props.outage?.number]);

  // Background refresh on its own identity-keyed effect: create the interval
  // once per problem/outage instead of clearing and recreating it on every
  // render (which previously kept the 60s poll from ever actually firing).
  useEffect(() => {
    if (!props.problem?.number || !props.outage?.number) return;
    const id = setInterval(() => refreshNotes(), 60 * 1000);
    return () => clearInterval(id);
  }, [props.problem?.number, props.outage?.number, refreshNotes]);

  return (
    <Container>
      <Row>
        <Col>
          <h5>
            <FaComment className="me-2" />
            Timeline Notes
          </h5>
          <NotesEditor
            problem={props.problem}
            outage={props.outage}
            postIt={NotesAPI.post}
            noteContents={noteContents}
            setNoteContents={setNoteContents}
            show={showModal}
            setShowModal={setShowModal}
            refresh={refreshNotes}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <ModernViewer
            notes={notes ? notes : []}
            deleteNote={deleteNote}
            refresh={() => {
              NotesAPI.get(props.problem.number, props.outage.number).then(
                (notes) => {
                  props.setOutage({
                    ...props.outage,
                    notes: notes,
                  });
                }
              );
            }}
            controls={props.controls}
            setMessage={editNote}
            showEyeballs={true}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default NotesTab;
